import { render } from "./VTableHeadSortable.vue?vue&type=template&id=cf1978f0&scoped=true"
import script from "./VTableHeadSortable.vue?vue&type=script&lang=js"
export * from "./VTableHeadSortable.vue?vue&type=script&lang=js"

import "./VTableHeadSortable.vue?vue&type=style&index=0&id=cf1978f0&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1978f0"]])

export default __exports__